import { Col, Input, Row, Select } from 'antd';
import { dialCodes } from '../../../../components/main/settings/otp-codes/dial-codes';
import Label from '../../label';
import React from 'react';
import PropTypes from 'prop-types';

export function PhoneNumberControl({ settings, name, onChange, onBlur, value, ...props }) {
  return (
    <Input
      value={value?.phone}
      onChange={event => onChange({ target: { name, value: { ...value, phone: event.target.value } } })}
      placeholder="Enter phone number"
      addonBefore={
        <Select
          style={{ width: 120 }}
          showSearch
          placeholder="Dial Code"
          dropdownMatchSelectWidth={false}
          optionLabelProp="dial-code"
          filterOption={(input, option) => {
            const { label, value } = option.props;
            return `${label}${value}`.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}
          value={value?.code}
          onChange={code => onChange({ target: { name, value: { ...value, code } } })}
        >
          {dialCodes.map(({ name, dialCode, isoCode }) => (
            <Select.Option key={isoCode} value={dialCode} label={name} dial-code={dialCode}>
              <Row>
                <Col span={6}>
                  <Label strong>({dialCode})</Label>
                </Col>
                <Col span={18}>
                  <Label width={200} ellipsis>
                    {name}
                  </Label>
                </Col>
              </Row>
            </Select.Option>
          ))}
        </Select>
      }
      style={{ width: '100%' }}
      {...props}
    />
  );
}

PhoneNumberControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  settings: PropTypes.object,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};
